export default {
    container: {
        width: '100%',
        height: '100%',
        backgroundColor: '#EEE'
    }
}